import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TextField, Paper, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get('/api/audit-logs');
      setLogs(res.data);
    } catch (err) {
      setLogs([]);
      setError('Kayıtlar alınamadı.');
    }
    setLoading(false);
  };

  const filteredLogs = logs.filter(l =>
    (l.user && l.user.toLowerCase().includes(filter.toLowerCase())) ||
    (l.action && l.action.toLowerCase().includes(filter.toLowerCase())) ||
    (l.details && l.details.toLowerCase().includes(filter.toLowerCase()))
  );

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Denetim Kayıtları</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <TextField label="Filtrele (kullanıcı/işlem/detay)" value={filter} onChange={e => setFilter(e.target.value)} fullWidth sx={{ mb: 1 }} />
      </Paper>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Kullanıcı</TableCell>
              <TableCell>İşlem</TableCell>
              <TableCell>Zaman</TableCell>
              <TableCell>Detay</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredLogs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">Kayıt bulunamadı.</TableCell>
              </TableRow>
            ) : filteredLogs.map((l) => (
              <TableRow key={l.id}>
                <TableCell>{l.user || l.user_id || '-'}</TableCell>
                <TableCell>{l.action || '-'}</TableCell>
                <TableCell>{l.time || l.timestamp || '-'}</TableCell>
                <TableCell style={{ maxWidth: 350, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{l.details || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default AuditLogs;
